import React from 'react';
import {Descriptions, DescriptionsProps} from 'antd';
import {useTranslation} from 'react-i18next';
import {PredictiveTrans} from './Trans';
import {FormatAsOutUnit} from '../../common/util/MeasurementValueUtils';
import {WarningIcon} from '../Common/WarningIcon';
import DateTimeUtils from '../Infrastructure/DateTime/DateTimeUtils';
import dayjs from 'dayjs';
import {ISensorInformation} from '@elproag/predict';
import {Sensor} from '../Common/Types/Sensor';

type PredictionInformationProps = {
	sensor: Sensor;
	sensorPredictiveInfo: ISensorInformation;
};

export function PredictionInformationView(props: PredictionInformationProps): React.JSX.Element {
	const [t] = useTranslation();
	const assessment = props.sensorPredictiveInfo?.assessments?.at(0);
	if (!assessment) {
		return null;
	}
	const latestAssessmentResult = assessment.assessmentResults?.at(-1);

	const items: DescriptionsProps['items'] = [
		{
			key: PredictiveTrans.qualifiedProfile,
			label: t(PredictiveTrans.qualifiedProfile).toString(),
			children: props.sensorPredictiveInfo.box.name,
		},
	];

	try {
		items.push(
			{
				key: 'lowerLimit',
				label: t(PredictiveTrans.lowerLimit).toString(),
				children: FormatAsOutUnit(assessment.lowerLimit, props.sensor.OutUnitsId),
			},
			{
				key: 'upperLimit',
				label: t(PredictiveTrans.upperLimit).toString(),
				children: FormatAsOutUnit(assessment.upperLimit, props.sensor.OutUnitsId),
			}
		);
	} catch (e) {}

	if (latestAssessmentResult?.breachExpectedAt) {
		items.push(
			{
				key: 'breachExpectedStatus',
				label: 'Breach expected',
				children: <WarningIcon event={{isAlarm: false}} />,
			},
			{
				key: 'breachExpectedAt',
				label: 'Breach expected at',
				children: DateTimeUtils.toUserString(dayjs(latestAssessmentResult.breachExpectedAt)),
			}
		);
	}

	return <Descriptions items={items} bordered={false} column={{xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 4}} />;
}
